var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20 0H0v20h20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 4.063c.489 0 .932.198 1.252.518.32.32.519.763.519 1.252v8.334c0 .489-.198.931-.519 1.252-.32.32-.763.518-1.252.518H3.75c-.489 0-.932-.198-1.252-.518a1.765 1.765 0 0 1-.519-1.252V5.833c0-.489.198-.931.519-1.252.32-.32.763-.519 1.252-.519Z",
    stroke: "#696F7F",
    strokeWidth: 1.458
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#696F7F",
    d: "M4.167 4.167h1.458V16.25H4.167zM14.375 4.167h1.458V16.25h-1.458z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#696F7F",
    d: "M2.083 7.5h3.333v1.458H2.083zM14.583 7.5h3.75v1.458h-3.75zM2.083 11.25h3.333v1.458H2.083zM14.583 11.25h3.75v1.458h-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.856 12.797V7.755l3.384 2.5-3.384 2.542Z",
    stroke: "#696F7F",
    strokeWidth: 1.7
  }))));
};
export default SvgVideo;